import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import ProfileAndCommentComponent from "../AppHome/ProfileAndCommentComponent";
import { useState } from "react";
const btnsData = [
  { title: "Location" },
  { title: "Role" },
  { title: "All Filters" },
];
const jobsData = [1, 2, 3, 4, 5, 6, 7, 8];
const suggestionsButtonsData = [
  { title: "Remote" },
  { title: "User Interface Designer" },
  { title: "User Experience Designer" },
  { title: "Senior User Interface Designer" },
  { title: "Senior Web Designer" },
  { title: "Web Designer" },
  { title: "User Interface Architect" },
];
function JobsSection() {
  const [isActive, setIsActive] = useState(0);
  return (
    <Stack>
      <Stack id="jobs-buttons" direction="row" spacing={1.5}>
        <Button
          variant="contained"
          sx={{
            alignSelf: "start",
            borderRadius: "20px",
            px: "18px",
            minWidth: "auto",
            width: "auto",
            textTransform: "none",
            bgcolor: "#FDDF59",
            color: "#000000",
            boxShadow: "none",
            py: "4px",
            "&:hover": {
              backgroundColor: "#fddf59",
              boxShadow: "none",
            },
            "&:active": {
              backgroundColor: "transparent",
              boxShadow: "none",
            },
            "&:focus": {
              outline: "none",
              boxshadow: "none",
            },
            "& .MuiButtonBase-root": {
              width: "auto !important",
              minWidth: "0px !important",
              padding: "0px",
              boxshadow: "none",
            },
          }}
        >
          Jobs
        </Button>
        {btnsData.map((btn) => (
          <Button
            variant="contained"
            sx={{
              py: "4px",
              alignSelf: "start",
              borderRadius: "20px",
              px: "18px",

              minWidth: "auto",
              width: "auto",
              textTransform: "none",
              bgcolor: "#ffffff",
              color: "#000000",
              boxShadow: "none",
              border: "1px solid #4E4E4E",
              "&:hover": {
                backgroundColor: "#ffffff",
                boxShadow: "none",
              },
              "&:active": {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
              "&:focus": {
                outline: "none",
                boxshadow: "none",
              },
              "& .MuiButtonBase-root": {
                width: "auto !important",
                minWidth: "0px !important",
                padding: "0px",
                boxshadow: "none",
              },
            }}
          >
            {btn.title}
          </Button>
        ))}
      </Stack>
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#EBEBEB",
          mx: "-20px",
          my: "16px",
          border: "none",
        }}
      />
      <Stack id="main" direction="row" spacing={1.2}>
        <Stack id="jobs-container" sx={{ width: "476px" }} spacing={1.5}>
          {jobsData.map((job, i) => {
            const activeJob = i === isActive;
            return (
              <Box
                component="button"
                sx={{
                  p: "12px",
                  borderRadius: "16px",
                  bgcolor: activeJob ? "#F8F8F8" : "#ffffff",
                  border: "1px solid #E3E3E3",
                  cursor: "pointer",
                }}
                onClick={() => setIsActive(i)}
              >
                <ProfileAndCommentComponent
                  avatarSrc="/images/smith.jpeg"
                  primaryText="Social Media Support"
                  secondaryText="Innovation Platform.Inc"
                  profile={true}
                  postDescription={true}
                  listButton={false}
                  jobSectionProfileCustomization={true}
                >
                  <Typography variant="body2" sx={{ justifySelf: "start" }}>
                    Capetown - Social Media Manager - Intership - On Site
                  </Typography>
                </ProfileAndCommentComponent>
              </Box>
            );
          })}
        </Stack>
        <Stack
          id="description-container"
          sx={{
            border: "1px solid #E3E3E3",
            width: "68%",
            bgcolor: "#F8F8F8",
            py: "12px",
            px: "22px",
            borderRadius: "16px",
            height: "max-content",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Brand Enthusiast Travel Blogger Chapter Host Voluntary Role
          </Typography>
          <Typography variant="subtitle2">
            Capetown - Social Media Manager - Intership - On Site
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: "bold", py: "14px", fontStyle: "italic" }}
          >
            Brand Enthusiast / Travel Blogger / Chapter Host (Voluntary Role)
          </Typography>
          <Typography variant="subtitle2">
            <span style={{ fontWeight: "bold" }}>Location:</span> Remote
          </Typography>
          <Typography variant="subtitle2" sx={{ py: "14px" }}>
            <span style={{ fontWeight: "bold" }}>Commitment:</span> Flexible
          </Typography>
          <Typography
            variant="subtitle2"
            //   sx={{ py: "14px" }}
          >
            Are you a passionate traveler, storyteller, or community builder
            looking to align with a meaningful cause? Do you want to inspire
            others through your journeys while giving back to the world? Join us
            as a Brand Enthusiast, Travel Blogger, or Chapter Host and become
            part of The Good Nomad Collective's mission to make a positive
            impact while travelling the world!
          </Typography>
          <Typography variant="subtitle2" sx={{ pt: "14px" }}>
            <span style={{ fontWeight: "bold", display: "block" }}>
              About Us
            </span>{" "}
            The Good Nomad Collective is a global movement empowering digital
            nomads and conscious travelers to leave places better than they
            found them. Through volunteering opportunities, social impact
            projects, and community- building events, we're redefining what it
            means to travel with purpose and heart.
          </Typography>
          <Typography variant="subtitle2" sx={{ py: "14px" }}>
            <span style={{ fontWeight: "bold", display: "block" }}>
              What You'll Do
            </span>{" "}
            As a Brand Enthusiast, Travel Blogger, or Chapter Host, you'll help
            amplify our mission and inspire others to join the movement. Your
            involvement could include:
          </Typography>
          <Typography variant="subtitle2">
            <span style={{ fontWeight: "bold" }}>• Sharing Your Story:</span>{" "}
            Create and share blogs, vlogs, or social media posts about your
            travel experiences, volunteering projects, and social impact
            stories.
          </Typography>
          <Typography variant="subtitle2">
            <span style={{ fontWeight: "bold" }}>
              • Promoting Conscious Travel:
            </span>{" "}
            Highlight volunteering opportunities, eco-tourism, and mindful
            travel practices through your unique voice and creativity.
          </Typography>
          <Typography variant="subtitle2">
            <span style={{ fontWeight: "bold" }}>• Starting a Chapter:</span>{" "}
            Become a Chapter Host in your favorite location, building a local
            Good Nomad Collective community. Lead or co-lead initiatives such as
            volunteering projects, meetups, or events that connect digital
            nomads, expats, and locals.
          </Typography>
          <Typography variant="subtitle2">
            <span style={{ fontWeight: "bold" }}>• Engaging Your Network:</span>{" "}
            Collaborate with local NGOs, businesses, and like-minded travelers
            to foster community and create meaningful impact.
          </Typography>
          <Typography variant="subtitle2">
            <span style={{ fontWeight: "bold" }}>
              • Representing the Movement:
            </span>{" "}
            Promote The Good Nomad Collective on your platforms and help grow a
            global community of purpose-driven travelers.
          </Typography>
          <Button
            variant="contained"
            sx={{
              alignSelf: "start",
              borderRadius: "28px",
              px: "24px",
              minWidth: "auto",
              width: "auto",
              textTransform: "none",
              bgcolor: "#000000",
              color: "#FFFFFF",
              boxShadow: "none",
              py: "12px",
              my: "20px",
              "&:hover": {
                backgroundColor: "#000000",
                boxShadow: "none",
              },
              "&:active": {
                backgroundColor: "#000000",
                boxShadow: "none",
              },
              "&:focus": {
                outline: "none",
                boxshadow: "none",
              },
              "& .MuiButtonBase-root": {
                width: "auto !important",
                minWidth: "0px !important",
                padding: "0px",
                boxshadow: "none",
              },
            }}
          >
            Apply For Job
          </Button>
        </Stack>
      </Stack>
      <Stack
        id="suggestion-container"
        sx={{
          bgcolor: "#F8F8F8",
          border: "1px solid #E3E3E3",
          mt: "28px",
          borderRadius: "12px",
          p: "20px",
          px: "28px",
        }}
      >
        <Typography variant="h6">Suggested Job Searches</Typography>
        <Stack
          id="suggestion-buttons"
          direction="row"
          sx={{ flexWrap: "wrap", gap: "12px", mt: "12px" }}
        >
          {suggestionsButtonsData.map((btn) => (
            <Button
              variant="contained"
              sx={{
                py: "4px",
                alignSelf: "start",
                borderRadius: "20px",
                px: "18px",
                minWidth: "auto",
                width: "auto",
                textTransform: "none",
                bgcolor: "transparent",
                color: "#000000",
                boxShadow: "none",
                border: "1px solid #000000",
                "&:hover": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:focus": {
                  outline: "none",
                  boxshadow: "none",
                },
                "& .MuiButtonBase-root": {
                  width: "auto !important",
                  minWidth: "0px !important",
                  padding: "0px",
                  boxshadow: "none",
                },
              }}
            >
              {btn.title}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
export default JobsSection;
